var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgWaveLightGold(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1440px",
    height: "434px",
    viewBox: "0 0 1440 434",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bg-wave-llight-gold") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 1440,
    height: 501
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboards-v1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard---Desktop",
    transform: "translate(0.000000, -700.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CBA-Section",
    transform: "translate(0.052221, 655.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bg-wave-llight-gold"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-61.052221,130 C196.947779,-2 330.947779,116 888.947779,161 C1260.94778,191 1460.94778,115.666667 1488.94778,-65 L1488.94778,417 C1230.94778,456.333333 974.281112,453.333333 718.947779,408 C494.381967,368.129308 299.947779,379 208.947779,408 C118.834137,436.717534 12.4489102,504.084991 -82.052221,472 C-310.499968,394.437501 -319.052221,262 -61.052221,130 Z",
    id: "Background",
    fill: "#BEAF92",
    opacity: 0.100000001,
    mask: "url(#mask-2)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgWaveLightGold);
export default __webpack_public_path__ + "static/media/bg-wave-light-gold.34907aa1ce2f1d89b6b959ba077efb2f.svg";
export { ForwardRef as ReactComponent };